import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysAutoCancelOrderMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();
  const { sysAutoCancelOrderContent: { tradeId } = {} } = raw;

  if (tradeId) {
    return (
      <SystemMessage>{t('ViewsChat.买家的取消订单x申请已自动同意', { tradeId })}</SystemMessage>
    );
  }

  return null;
});
